import { ActuatorApi, AuthenticationApi, DashboardApi, EmergencyApi, ForgottenPasswordApi, MediaApi, RiskApi } from '@qcs/safety-client';
import { api } from '@api/apiClient';

// The axios instance, its interceptors and the token refresh live in the API handler
// (@api/apiClient). Re-exported here while the call sites still import it from this file.
export { BASE_URL_WITH_VERSION } from '@api/apiClient';

// @qcs/safety-client has older version of axios, "api as any" replace with new axios (different types is OK, we dont use configuration)

const BASE_URL = import.meta.env.VITE_API_URL as string;

export const authenticationApi = new AuthenticationApi(undefined, BASE_URL, api as any);

export const riskApi = new RiskApi(undefined, BASE_URL, api as any);

export const mediaApi = new MediaApi(undefined, BASE_URL, api as any);

export const emergencyApi = new EmergencyApi(undefined, BASE_URL, api as any);

export const forgottenPasswordApi = new ForgottenPasswordApi(undefined, BASE_URL, api as any);

export const dashboardApi = new DashboardApi(undefined, BASE_URL, api as any);

export const actuatorApi = new ActuatorApi(undefined, BASE_URL, api as any);
